import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Steps } from "primereact/steps";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { JVChips } from "../../../shared/JVChips";
import { JVInput } from "../../../shared/JVInput";
import { Toolbar } from "primereact/toolbar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Editor } from "primereact/editor";
import { Fetch } from "../../../shared/Fetch";
import { ISignatureMast } from "../../../models/SignatureMast";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import RichTextEditor from "../../../shared/RichTextEditor";

interface IProps {
    open: boolean;
    singleData: ILeadScrappingJobs;
    hideDialog: () => void;
    toast: any;
}

interface ILeadScrappingJobs {
    companyName?: string,
    companyUrl?: string,
    createdAt?: Date,
    createdBy?: number,
    id?: number,
    jobDescription?: string,
    jobTitle?: string,
    jobType?: string,
    jobUrl?: string,
    pocCount?: number,
    source?: string,
    pocs?: IPOCs[],
    emails_Sent?: IMailHistory[],
    email_Limit?: number,
}

interface IPOCs {
    id?: number,
    pocName?: string,
    pocEmail?: string,
    createdAt?: Date,
}

interface IMailHistory {
    id?: number,
    email_Subject?: string,
    email_Body?: string,
    email_CC?: string,
    send_By?: number,
    send_At?: Date,
    jobID?: number,
    pocID?: number,
    poc_Email?: string,
}

interface IMail {
    emailCC: string[] | null;
    subject: string;
    emailBody: string;
    to_Self: boolean;
    emailTo?: string;
}

interface IEmailTemplate {
    template_Id?: number;
    companyId?: number;
    companyName?: string;
    template_Name?: string;
    template_Subject: string;
    template_Body: string;
}

interface IPOC_Emails {
    email?: string,
    name?: string,
    isUpdate: boolean
}

const schema = yup.object({
    // emailTo: yup.string().email("Invalid Email ID").required("This field is required"),
    emailCC: yup.array().of(yup.string().email("Invalid Email ID").nullable()).nullable(),
    subject: yup.string().required("Email Subject is required"),
    to_Self: yup.boolean().nullable(),
});

export const NewDraftEmaills = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loading2, setLoading2] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [indexs, setIndexs] = useState<number>(0);
    const [templates, setTemplates] = useState<IEmailTemplate[]>([]);
    const [draftedEmail, setDraftedEmail] = useState<IMail>({ emailCC: null, subject: "", emailBody: "", to_Self: false, emailTo: "" });
    const [body, setBody] = useState<string>("");
    const [signature, setSignature] = useState("");
    const [disclaimer, setDisclaimer] = useState(`<b style="color:red;">Disclaimer</b><p style="color:black;">: This email and any attachments are intended for business communication purposes only. The information contained herein is intended for the designated recipient. If you have received this email in error, please notify the sender and disregard its contents. The views and opinions expressed in this email are those of the sender unless otherwise stated as representing the company. Please consider the environment before printing this email.</p>`);
    const [pocEmails, setPocEmails] = useState<Array<IPOC_Emails>>([]);
    const [deletedPOCEmails, setDeletedPOCEmails] = useState<Array<IPOC_Emails>>([]);
    const [checked, setChecked] = useState<number[]>([]);
    const [emailPatterns, setEmailPatterns] = useState<Array<string>>([]);
    const [openDetailsModel, setOpenDetailsModel] = useState({ open: false, singleData: "", typeName: "" } as { open: boolean, singleData: string, typeName: string });

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IMail>({
        resolver: yupResolver(schema),
        defaultValues: {
            to_Self: true,
            emailCC: null,
            subject: "",
            emailBody: "",
        },
        shouldFocusError: false,
    });

    const header = () => {
        return <p>Send Email To POC</p>;
    }

    const onHide = () => {
        reset({ emailCC: null, subject: "", emailBody: "" });
        setBody("");
        setEmailPatterns([]);
        setDraftedEmail({ emailCC: null, subject: "", emailBody: "", to_Self: false, emailTo: "" });
        setDisclaimer(`<b style="color:red;">Disclaimer</b><p style="color:black;">: This email and any attachments are intended for business communication purposes only. The information contained herein is intended for the designated recipient. If you have received this email in error, please notify the sender and disregard its contents. The views and opinions expressed in this email are those of the sender unless otherwise stated as representing the company. Please consider the environment before printing this email.</p>`);
        setIndexs(0);
        setPocEmails([]);
        setChecked([]);
        setLoading(false);
        setLoading2(false);
        setActiveIndex(0);
        props.hideDialog();
    }

    const loadSignature = async () => {
        setLoading(true);
        try {
            const response = await Fetch("Signature_Mast", "GET", null, null, props.toast);
            if (response) {
                const data: ISignatureMast = await response.json();
                setSignature(data.signature ?? "");
            }
        } finally {
            setLoading(false);
        }
    };

    const interactiveItems = [
        { label: 'Email Body' },
        { label: `Select POC's` }
    ];

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" type="button" tooltip="Reload Email Template" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    const takeTempIndex = (indexs + 1 === templates.length) ? 0 : (indexs + 1);
                    const emaill: IEmailTemplate = templates[takeTempIndex];
                    setIndexs(takeTempIndex);
                    if (emaill.template_Subject) {
                        setValue("subject", emaill.template_Subject);
                    }
                    if (emaill.template_Body) {
                        // setBody((emaill.template_Body + "</br>" + `<a href="${props.singleData.jobUrl}">${props.singleData.jobTitle}</a>`));
                        setBody((emaill.template_Body + "</br>" + `<p style="color:red;"><strong>@jobTitle</strong></p>`));
                    }
                }} />
            </React.Fragment>
        );
    };

    const loadCompanyTemplates = async () => {
        setLoading(true);
        const response = await Fetch("lead-capture/getCompanyEmailTemplatesByUser", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();

            const templateData: IEmailTemplate[] =
                Array.isArray(data)
                    ? data.map((item: any) => ({
                        template_Id: item.ID ?? item.id ?? item.template_Id,
                        companyId: item.Company_ID ?? item.companyID ?? item.companyId,
                        companyName: item.Company_Name ?? item.companyName,
                        template_Subject: item.Email_Subject ?? item.email_Subject ?? item.template_Subject ?? "",
                        template_Body: item.Email_Template ?? item.email_Template ?? item.template_Body ?? "",
                    }))
                    : [];

            setTemplates(templateData);

            const prevCeleb = localStorage.getItem('pocReachTemplate');
            if (prevCeleb !== "" && prevCeleb !== undefined && prevCeleb !== null && JSON.parse(prevCeleb || "").poc_ReachTemplateBody !== undefined && JSON.parse(prevCeleb || "").poc_ReachTemplateBody !== null) {
                setBody((prev: string) => prev = JSON.parse(prevCeleb || "").poc_ReachTemplateBody);
                setValue("subject", JSON.parse(prevCeleb || "").poc_ReachTemplateSubject);
            } else {
                const takeTempIndex = Math.floor(Math.random() * templateData.length);

                setIndexs(takeTempIndex);

                const emaill: IEmailTemplate = templateData[takeTempIndex];

                if (emaill.template_Subject) {
                    setValue("subject", emaill.template_Subject);
                }

                if (emaill.template_Body) {
                    setBody((emaill.template_Body + "</br>" + `<p style="color:red;"><strong>@jobTitle</strong></p>`));
                }
            }

            setLoading(false);
        } else setLoading(false);
    };

    function onSubmit(data: IMail) {
        const plain = (body || "").replace(/<[^>]*>/g, "").trim();
        if (plain.length < 10)
            props.toast.current.show({ severity: "error", detail: "Mail Body is Required With Atleast 10 Characters.", life: 3000 });
        else if (!body.includes("@jobTitle")) {
            props.toast.current.show({ severity: "warn", detail: "Please add @jobTitle to the email body. It will be replaced with the job title and a link to the corresponding job when the email is sent.", life: 3000 });
        } else {
            const emailBody = body.replace('@jobTitle', `<a href="${props.singleData.jobUrl || ""}" target="_blank">${props.singleData.jobTitle || "jobTitle"}</a>`);
            setDraftedEmail({
                emailCC: data.emailCC,
                subject: data.subject,
                emailBody: (emailBody + "</br>" + signature + "</br>" + disclaimer),
                to_Self: data.to_Self,
            });
            setActiveIndex(activeIndex + 1);
        }
    }

    const onSendEmail = async () => {
        if (checked.length === 0) {
            props.toast.current.show({ severity: "warn", detail: "Please Select At Least 1 Email To Send Email", life: 3000 });
        } else {
            const drafted_To_Emails: any[] = pocEmails.filter((el: IPOC_Emails, index: number) => checked.includes(index)).map((el: any) => {
                return {
                    toSelf: draftedEmail.to_Self || false,
                    emailTo: el.email,
                    subject: draftedEmail.subject,
                    emailBody: draftedEmail.emailBody,
                    emailCC: (draftedEmail.emailCC || []).map((el: string) => el.trim()).filter(Boolean),
                    jobID: props.singleData.id,
                }
            });

            setLoading(true);
            setLoading2(true);
            try {
                const response = await Fetch(`lead-capture/sendEmails`, "POST", drafted_To_Emails, null, props.toast);
                if (response) {
                    setLoading(false);
                    setLoading2(false);
                    props.toast.current.show({ severity: "success", detail: "Mail Distributed Successfully.", life: 3000 });
                    onHide();
                }
            } finally {
                setLoading(false);
                setLoading2(false);
            }
        }
    }

    const loadDraftedEmails = async () => {
        setLoading2(true);
        const response = await Fetch("lead-capture/getDraftedEmails", "GET", null, `jobID=${props.singleData.id}`, props.toast);
        if (response) {
            const data: any = await response.json();

            const list: any[] = Array.isArray(data) ? data : data?.data ?? [];

            const mapped = list;

            const maxLimit: number = (props.singleData.email_Limit || 0);

            setLoading2(false);

            if ((props.singleData.emails_Sent || []).length < maxLimit) {
                if (mapped.length > (maxLimit - (props.singleData.emails_Sent || []).length)) {
                    setPocEmails(data.map((el: any) => {
                        return {
                            email: el,
                            name: "",
                            isUpdate: false
                        };
                    }).filter((el: any, indx: number) => (indx + 1) <= maxLimit));
                } else if (mapped.length == (maxLimit - (props.singleData.emails_Sent || []).length)) {
                    setPocEmails(data.map((el: any) => {
                        return {
                            email: el,
                            name: "",
                            isUpdate: false
                        };
                    }));
                } else {
                    const newEmails = data.map((el: any) => {
                        return {
                            email: el,
                            name: "",
                            isUpdate: false
                        };
                    });

                    if (mapped.length < (maxLimit - (props.singleData.emails_Sent || []).length)) {
                        if (((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim() !== "" && ((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim().includes("@")) {
                            loadEmailPatterns("", ((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim().split("@")[1]);
                        } else if (props.singleData.companyUrl && props.singleData.companyUrl.trim() !== "") {
                            loadEmailPatterns("", props.singleData.companyUrl);
                        } else if (props.singleData.companyName && props.singleData.companyName.trim() !== "") {
                            loadEmailPatterns(props.singleData.companyName, "");
                        };

                        const addEmails: number = (maxLimit - (props.singleData.emails_Sent || []).length) - mapped.length;
                        let addNewEmails = [...newEmails];
                        for (let i = 0; i < addEmails; i++) {
                            addNewEmails.push({
                                email: "",
                                name: (props?.singleData?.pocs || [{ pocName: "" }]).map((el: any) => el?.pocName).join(", "),
                                isUpdate: true
                            });
                        }
                        setPocEmails(addNewEmails);
                    } else setPocEmails(newEmails);
                }
            }
            // setPocEmails([{
            //     email: "",
            //     name: (props?.singleData?.pocs || [{ pocName: "" }]).map((el: any) => el?.pocName).join(", "),
            //     isUpdate: true
            // }]);

            // if (((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim() !== "" && ((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim().includes("@")) {
            //     loadEmailPatterns("", ((props?.singleData?.pocs || [])[0]?.pocEmail ?? "").trim().split("@")[1]);
            // } else if (props.singleData.companyUrl && props.singleData.companyUrl.trim() !== "") {
            //     loadEmailPatterns("", props.singleData.companyUrl);
            // } else if (props.singleData.companyName && props.singleData.companyName.trim() !== "") {
            //     loadEmailPatterns("", props.singleData.companyName);
            // }

        } else setLoading2(false);
    };

    const loadEmailPatterns = async (vendorCompanyId: string, domain: string) => {
        setLoading2(true);
        const response = await Fetch("name_email_patterns", "GET", null, domain.trim() !== "" ? `domainc=${encodeURIComponent(JSON.stringify(domain))}` : `vendorCompanyName=${vendorCompanyId}`, null);
        if (response) {
            const data: Array<string> = await response.json();
            if (domain.trim() !== "" && vendorCompanyId.trim() === "" && data.length === 0) {
                if (props.open && props.singleData.companyName) {
                    loadEmailPatterns(props.singleData.companyName, "");
                }
            }
            setEmailPatterns(data);
            setLoading2(false);
        } else setLoading2(false);
    }

    const saveTemplateAndNext = () => {
        props.toast.current.show({ severity: "success", detail: "Mail Template Saved For All Next POC Reach Email.", life: 3000 });
        const prevCeleb = localStorage.getItem('pocReachTemplate');
        if (prevCeleb !== "" && prevCeleb !== undefined && prevCeleb !== null && JSON.parse(prevCeleb || "").poc_ReachTemplateBody !== undefined && JSON.parse(prevCeleb || "").poc_ReachTemplateBody !== null) {
            localStorage.removeItem('pocReachTemplate');
            localStorage.setItem('pocReachTemplate', JSON.stringify({ poc_ReachTemplateSubject: control._formValues.subject, poc_ReachTemplateBody: body }));
        } else localStorage.setItem('pocReachTemplate', JSON.stringify({ poc_ReachTemplateSubject: control._formValues.subject, poc_ReachTemplateBody: body }));
    }

    useEffect(() => {
        if (props.open) {
            loadCompanyTemplates();
            loadSignature();
            if (props.singleData.id) loadDraftedEmails();
            setValue("to_Self", true);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: "85vw", height: "87vh" }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows showGridlines resizableColumns scrollable lazy dataKey="id"
                value={[props?.singleData]}
                emptyMessage="No Records found."
                header={<></>}
                loading={false}
            >
                <Column field="source" header="Source" />
                <Column field="companyName" header="Company Name" />
                <Column field="jobDescription" header="Job Description" body={(rowData: ILeadScrappingJobs) => <div onClick={() => setOpenDetailsModel({ open: true, singleData: (rowData.jobDescription || ""), typeName: "Job Description" })} className="flex"><Button label={rowData.jobDescription} className="p-button-rounded p-button-info p-button-text" style={{ width: "7rem" }} /><span style={{ marginTop: "9px", color: "#0288d1", cursor: "pointer" }}>...</span></div>} />
                <Column field="jobTitle" header="Job Title" body={(rowData: ILeadScrappingJobs) => <Button label={`${rowData.jobTitle}`} className="p-button-rounded p-button-text p-button-plain" tooltip={`${rowData.jobTitle}`} />} />
                <Column field="jobType" header="Job Type" />
                <Column field="jobUrl" header="Job Url" body={(rowData: ILeadScrappingJobs) => {
                    const jobUrl = rowData.jobUrl || ""; const openJobUrl = () => {
                        if (!jobUrl) return;
                        const url = /^https?:\/\//i.test(jobUrl) ? jobUrl : `https://${jobUrl}`;
                        window.open(url, "_blank", "noopener,noreferrer");
                    };

                    return (
                        <div className="flex">
                            <Button label={jobUrl} className="p-button-rounded p-button-text p-button-plain" style={{ width: "7rem", background: "transparent", border: "none", outline: "none", boxShadow: "none", color: "#0288d1", }}
                                tooltip={jobUrl || "No URL available"} tooltipOptions={{ position: "top" }} onClick={openJobUrl} disabled={!jobUrl}
                            />
                            <span style={{ marginTop: "9px", color: "#0288d1", cursor: jobUrl ? "pointer" : "default", }} title={jobUrl || "No URL available"} onClick={openJobUrl}>
                                ...
                            </span>
                        </div>
                    );
                }}
                />
            </DataTable>
            <Steps className='mt-1 mb-2' model={interactiveItems} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} />
            <hr />
            <div style={{ height: "55vh", overflowY: "scroll", padding: "10px" }}>
                {activeIndex === 0 && <div>
                    <form id="emailBodyForm" onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                        <div
                            className="field col-12 md:col-12 p-fluid formgrid grid ml-3 mt-1"
                            style={{ display: "grid", gridTemplateColumns: "2fr 1fr", border: "1px solid #ced4da", borderRadius: "5px", width: "90%", alignItems: "flex-end", }}
                        >
                            <div
                                className="col-12 md:col-12 mb-3"
                                style={{ display: "flex", alignItems: "center", gap: "20px", }}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <JVCheckbox column={1} label="To Self" control={control} name="to_Self" />
                                </div>
                                <JVChips column={1} label="CC (just Copy and paste emails, Do Not Write/Type)" control={control} name="emailCC" error={errors.emailCC && errors.emailCC?.message} separator="," />
                            </div>
                        </div>
                        <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
                        <Toolbar className="mb-1 py-0 field col-12 md:col-12" right={leftToolbarTemplate}></Toolbar>
                        <div className="col-12 md:col-12 md:col-6 mb-3">
                            <label>
                                Body<span style={{ color: "red" }}>*</span> {" ("} <b>Do not remove <span style={{ color: "red" }}>@jobTitle</span> from email body, you can update it's position</b> It will be replaced with the job title and a link to the corresponding job when the email is sent.{")"}
                            </label>

                            {/* <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} /> */}
                            <RichTextEditor value={body} onChange={(newContent) => setBody(newContent)} height={400} placeholder="Write your email body here..." />

                        </div>
                        <div className="col-12 md:col-12 md:col-6">
                            <label htmlFor="signature">Full Signature</label>
                            {/* <Editor value={signature} onTextChange={(e) => setSignature(e.htmlValue || "")} /> */}
                            <RichTextEditor value={signature} onChange={(newContent) => setSignature(newContent)} height={250} placeholder="Enter your email signature..." />
                        </div>
                        <div className="col-12 md:col-12 md:col-6">
                            <label htmlFor="signature">Disclaimer</label>
                            {/* <Editor value={disclaimer} onTextChange={(e) => setDisclaimer(e.htmlValue || "")} /> */}
                            <RichTextEditor value={disclaimer} onChange={(newContent) => setDisclaimer(newContent)} height={250} placeholder="Enter your email disclaimer..." />
                        </div>
                    </form>
                </div>}
                {activeIndex === 1 && <>
                    <div>
                        <Button label="Add POC Emails" icon="pi pi-plus" className="p-button-success mr-2 my-2 w-2" onClick={() => {
                            if ((Number(props.singleData.email_Limit || "0") - Number((props.singleData.emails_Sent || [])?.length)) > pocEmails.length) {
                                if (pocEmails.filter((email_: IPOC_Emails) => email_.isUpdate === true).length === 0) {
                                    if (props.singleData.companyUrl && props.singleData.companyUrl.trim() !== "") {
                                        loadEmailPatterns("", props.singleData.companyUrl);
                                    } else if (props.singleData.companyName && props.singleData.companyName.trim() !== "") {
                                        loadEmailPatterns(props.singleData.companyName, "");
                                    }
                                }
                                const newpocEmails: IPOC_Emails[] = [...pocEmails, {
                                    email: "",
                                    name: (props?.singleData?.pocs || [{ pocName: "" }]).map((el: any) => el?.pocName).join(", "),
                                    isUpdate: true
                                }];
                                setPocEmails(prev => prev = newpocEmails);
                            } else props.toast.current.show({ severity: "warn", detail: "Can Not Add More Emails As Per Limit", life: 3000 });
                        }} />
                    </div>
                    <div>
                        {loading2 === true && <p>Loading POC...</p>}
                        {pocEmails.map((el: IPOC_Emails, ind: number) => <div key={ind} style={{ border: "1px solid rgb(206, 212, 218)", borderRadius: "2px", padding: "10px" }}>
                            <div className="flex flex-column">
                                <div className="flex justify-content-between">
                                    <div className="flex gap-5 align-items-center">
                                        <Checkbox onChange={e => {
                                            if (e.checked === true) {
                                                const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                if (el.email?.trim() === "") {
                                                    props.toast.current.show({ severity: "warn", detail: "Can Not Select Empty Email", life: 3000 });
                                                } else if (!pattern.test(el.email?.trim() || "")) {
                                                    props.toast.current.show({ severity: "warn", detail: "Not Correct Email Format", life: 3000 });
                                                } else setChecked(prev => prev = [...checked, ind]);
                                            }
                                            else setChecked(prev => prev = checked.filter((ele: any, indi: number) => (indi !== ind)));
                                        }} checked={checked.includes(ind)}></Checkbox>
                                        {el.isUpdate === true ? <div>
                                            <label>Enter POC Email : {"( "} {el.name} {" )"}</label>
                                            <InputText value={el.email} onChange={(e) => {
                                                if (e.target.value?.trim() === "") {
                                                    setChecked(prev => prev = checked.filter((ele: any, indi: number) => (indi !== ind)));
                                                };
                                                setPocEmails(prev => prev = pocEmails.map((pc: IPOC_Emails, indy: number) => {
                                                    return indy === ind ? { ...pc, email: e.target.value } : pc;
                                                }));
                                            }} />
                                        </div> : <p>{`POC_${ind + 1}@${(el.email || "@_").split("@")[1]}`}</p>}
                                    </div>
                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-text mr-1" style={{ color: "red" }} onClick={() => {
                                        if (checked.includes(ind)) {
                                            setChecked(prev => prev = checked.filter((ele: any, indi: number) => (indi !== ind)))
                                        };
                                        setPocEmails(prev => prev = pocEmails.filter((pc: IPOC_Emails, indy: number) => indy !== ind));
                                        if (el.isUpdate !== true) {
                                            setDeletedPOCEmails([...deletedPOCEmails, el]);
                                        }
                                    }} />
                                </div>
                                {el.isUpdate === true && <div className="mt-1 ml-7">
                                    <p>Email Patterns: {loading2 === true ? "Loading..." : ""} {emailPatterns.length > 0 && <span className="text-purple-500 font-bold">{emailPatterns.join("  |  ")}</span>}</p>
                                </div>}
                            </div>
                        </div>)}
                    </div></>
                }
            </div>
            <hr />
            <div className='flex flex-row-reverse gap-3 mt-5'>
                {activeIndex === 1 && <Button loading={loading2} className='w-9rem' onClick={onSendEmail} label='SEND EMAIL'></Button>}
                {activeIndex < 1 && <Button loading={loading} className='w-10rem' tooltip="Save This Template For All Next POC Reach" label='SAVE TEMPLATE & NEXT' form="emailBodyForm" type={loading === false ? "submit" : "button"} onClick={saveTemplateAndNext}></Button>}
                {activeIndex < 1 && <Button loading={loading} className='w-10rem' label='SAVE & NEXT' form="emailBodyForm" type={loading === false ? "submit" : "button"}></Button>}
                {activeIndex > 0 && <Button loading={loading} className='w-7rem p-button-outlined' onClick={() => setActiveIndex(activeIndex - 1)} label='PREVIOUS'></Button>}
            </div>
            <Dialog visible={openDetailsModel.open} style={{ width: '80vw' }} header={openDetailsModel.typeName} modal className="p-fluid" onHide={() => setOpenDetailsModel({ open: false, singleData: "", typeName: "" })}>
                <Card style={{ overflowY: "scroll", maxHeight: "65vh" }}>
                    {openDetailsModel.singleData}
                </Card>
            </Dialog>
        </Dialog>
    );
}